<template>
  <div>
    <div class="view-area">
      <div class="info-area">
        <iframe class="form-area" src="https://docs.google.com/forms/d/e/1FAIpQLSckK797hCZYaXZ8GxipZJJqjM-7o65veuXegFxkIr-_VajX1A/viewform?embedded=true" frameborder="0" marginheight="0" marginwidth="0">読み込んでいます…</iframe>
      </div>
    </div>
    <Footer />
    <Menu />
  </div>
</template>

<script>
import Footer from './modules/Footer'
import Menu from './modules/Menu'

export default {
  name: 'Contact',
  components: {
    Footer,
    Menu
  }
}
</script>

<style scoped>
.view-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}
@supports (-webkit-touch-callout: none) {
  .view-area {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.info-area {
  display: flex;
  justify-content: center;
}
.info-title-img {
  max-width: 192px;
  margin: 0 24px;
}
.form-area {
  width: 630px;
  height: 72vh;
}
.text {
  font-size: 13px;
  color: #000;
  letter-spacing: 4.5px;
}
@media (max-width: 639px) {
  .info-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .info-title-img {
    max-width: 144px;
  }
  .form-area {
    width: 94vw;
    height: 71vh;
    margin-bottom: 40px;
  }
  .text {
    font-size: 11px;
    padding-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue